export enum FeatureToggle {
  SeoEnabled = 'rt_ipp_seo',
}
